<template>
  <div class="mainWrap">
    <div class="tutorial_main tutorial_main_education">
      <div class="nav_filter_wrap">
        <div class="up_wrap">
          <div class="icon" @click="goBack">
            <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
          </div>
          <div class="main_wrap">
            <div class="left">
              <a
                v-for="(item, index) in nav" :key="index"
                :class="{btn: true, active: res_type===index}"
                @click="switchTab(index)"
              >{{item}}</a>
            </div>
            <div class="right">
              <div class="tip-right"> 培训班结束以后<span v-if="end_date">（{{end_date | time(false) }} 24:00）</span>，教案会自动提交，教案也将无法再次编辑。</div>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="mainHeader">
          <div class="tips">
            <p>全部教案</p>
          </div>
          <div class="searchWrap">
            <div class="wrap">
              <input
                type="text"
                v-model.lazy.trim="req_data.search_keywords"
                @keyup.enter="search"
                placeholder="输入您想要查找的教案内容"
              >
              <div v-show="req_data.search_keywords!=''" class="close" @click="hideIcon">
                <v-icon name="regular/times-circle" scale="1.2"></v-icon>
              </div>
            </div>
            <div class="search" @click="search">搜索</div>
          </div>
        </div>
        <template v-if="showList">
          <div class="mainBody">
            <vue-scroll :ops="ops" ref="vs">
              <div class="contentWrap">
                <div class="content">
                  <div
                    class="tutorialItem"
                    v-for="(item, index) in list"
                    :key="index"
                    @click="lookOverDetail(item.plan_id)"
                  >
                    <div class="up">
                      <div class="imgWrap">
                        <img :src="item.drill_id | addSrc(item.last_updated)" alt @error="imgTutorialErr($event)">
                        <span v-if="item.is_owner" @click.stop="downloadPDF(item.plan_id)" class="load_btn"><v-icon class='svg' name="file-pdf" scale="1.1"></v-icon>
                        <span class="down_text">下载/打印</span>
                        </span>
                        <tutorial-type :excellent="item.is_excellent" :type="item.session_type"></tutorial-type>
                        <tutorial-excellent v-if="Number(item.is_excellent) === 1"></tutorial-excellent>
                      </div>
                      <div class="title">
                        <p>{{item.title}}</p>
                        <p class="author">作者：{{item.user_name}}</p>
                      </div>
                    </div>
                    <div class="down">
                      <!-- <p class="author">作者：{{item.user_name}}</p> -->
                      <!-- <p class="updateTime">更新：{{item.last_updated | time}}</p> -->
                      <p class="club_name">{{item.class_name}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
          <div id="paging">
            <yioks-paging :paging="paging" @goto-page="gotoPage($event)"></yioks-paging>
          </div>
        </template>
        <yioks-empty v-show="showEmpty" :h="'500px'"></yioks-empty>
        <el-dialog class="eval-dialog"
          :visible.sync="allDisabled"
          title
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :show-close="false"
          width="580px"
          center>
          <div class="to-eval">
            <div class="img">
              <img src="@/assets/images/evaluation_tips.png" alt>
            </div>
            <div class="tips">
              <p v-html="tips.title"></p>
            </div>
            <el-button type="primary" @click="gotoSetting">{{tips.button_text}}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-awesome/icons/file-pdf";
import tutorialMixin from "@/minix/tutorial-students";
import { myTutorial, downloadTutorial } from "@/api/training_student/api";
import commonFun from "@/assets/js/yioks";
const { downfile } = commonFun;
import {isEvaluated} from "@/api/training_student/api";
import fiveMixins from '@/minix/fiveMixins';

export default {
  name: "tutorial-person",
  mixins: [tutorialMixin, fiveMixins],
  data() {
    const nav = ["我的教案"];
    return {
      nav,
      tips:{
        title:"",
        button_text:"",
        show_type:"",
      },
      res_type : 0,
      end_date : this.$route.query.end_date,
      allDisabled: false,
      downPdfFlag: false,
      libraryVideo : 'https://www.baidu.com/',
    };
  },
  components: {
    "yioks-status": () => import("@/components/Tips/Status"),
  },
  created() {
    this.isEvaled();
  },
  methods: {
    downloadPDF(plan_id) {
      if(this.downPdfFlag) return;
      this.downPdfFlag = true;
      downloadTutorial({ plan_id })
        .then(({data}) => {
          if (Number(data.status) === 0) {
            downfile(data.result.pdf_url);
          }
          this.downPdfFlag = false;
        })
        .catch(err => {
          this.downPdfFlag = false;
          console.error(err);
        });
    },
    goBack() {
      // this.$router.go(-1);
      this.$router.push({
        path: "class_detail",
        query: {}
      });
    },
    handleRequest() {
      if (this.res_type === 0) {
        this.reqMyList();
      }
    },
    reqMyList() {
      myTutorial({ ...this.req_data, page: this.page })
        .then(res => {
          // console.log(res);
          this.handleData(res.data);
        })
        .catch(err => {
          console.error(err);
        });
    },
    isEvaled() {
      isEvaluated().then(({data}) => {
        if (data.status === 0) {
          this.allDisabled =  data.result.eva_show === 1 ;
          this.tips.title="培训班即将结束，请您填写问卷调查。";
          this.tips.button_text="前往问卷调查";
          this.tips.show_type="eva_show";
        }
      });
    },
    gotoSetting(){
      if(this.tips.show_type === 'eva_show'){
        this.$router.push({name:'StuCreateEvaluation'});
      }
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/tutorial-person'
@import "~@/assets/css/nav_filter";
.eval-dialog
  .to-eval
    font-size 16px
    text-align center
    img
      width 100px
    .tips
      margin-bottom 15px
.tutorial_main_education
  .up_wrap
    border-bottom 0px
    padding-bottom 10px
  .main
    height 600px
  .tip-right
    color $color_unusual
    font-size 16px
</style>
